module.exports = "::ng-deep .custom-tooltip {\n\tfont-size: 14px;\n\tbackground: #6ee229;\n}\np{\n\tmargin-top: 0;\n}\np.info{\n\tmargin-bottom: 0;\n\tmargin-top: 8px;\n}\np.info a{\n\ttext-decoration: none;\n}\n.res_error{\n\tfont-size: 14px;\n    margin-top: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/express-pay/express-pay/express-pay.component.css
// module id = ./src/app/payment/express-pay/express-pay/express-pay.component.css
// module chunks = main